import { put, call, takeEvery } from 'redux-saga/effects';
import { message } from 'antd';

import { API_BASE_URL } from 'src/globals';
import apiProvider from '../api/provider';
import { EDIT_REFERENCE_RATES_ROUTE } from '../api/routes';
import {
  EDIT_REFERENCE_RATES,
  EDIT_REFERENCE_RATES_SUCCESS,
  EDIT_REFERENCE_RATES_FAILED,
 } from '../actions/constants';
import { getAuthenticationHeaders } from '../api/utils';

export function* updateReferenceRates(action) {
  try {
    const response = yield call(() => apiProvider.post(
      `${API_BASE_URL}${EDIT_REFERENCE_RATES_ROUTE}`,
      action.payload,
      { headers: getAuthenticationHeaders() },
    ));
    yield put({ type: EDIT_REFERENCE_RATES_SUCCESS, payload: response });
  } catch (err) {
    message.error(err.errorMessage);
    yield put({ type: EDIT_REFERENCE_RATES_FAILED, payload: err });
  }
}

export function* referenceRateSaga() {
  yield takeEvery(EDIT_REFERENCE_RATES, updateReferenceRates);
}

export default referenceRateSaga;
